import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// axios
import axios from "axios";
import VueAxios from "vue-axios";
//swal
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
//session
import VueSession from "vue-session";

import vuetify from './plugins/vuetify';
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { VueMaskDirective } from 'v-mask'
import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css' // import the croppie css manually

Vue.config.productionTip = false
Vue.use(VueQuillEditor);
Vue.use(VueSession);
Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.use(VueCroppie);
Vue.directive('mask', VueMaskDirective);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// require styles

require("./assets/css/main.css");
require("./assets/fonts/stylesheet.css");

